
import { executeMutation, executeQuery } from "utils/services/apiServices";
import { showSnackbar } from "utils/snack_bar/store/action";
import { FETCH_CHEYCHEY_IMAGE } from "../graphql/query";
import { actionTypes, CheyCheyImageProps } from "./actionType";
import { CREATE_CHEY_CHEY_IMAGE, DELETE_CHEY_CHEY_IMAGE } from "../graphql/mutation";
import { title } from 'process';

export const fetchCheyCheyImageRequest = () => ({
  type: actionTypes.FETCH_CHEYCHEY_IAMGE_REQUEST,
});

export const fetchCheyCheyImageSuccess = (payload: CheyCheyImageProps[]) => ({
  type: actionTypes.FETCH_CHEYCHEY_IAMGE_SUCCESS,
  payload,
});

export const fetchCheyCheyImageFail = (payload: string) => ({
  type: actionTypes.FETCH_CHEYCHEY_IAMGE_FAIL,
  payload,
});

export const fetchCheyCheyImage = () => {
  return async (dispatch: any) => {
    try {
      await dispatch(fetchCheyCheyImageRequest());
      const response = await executeQuery(FETCH_CHEYCHEY_IMAGE);
      const jsonData = response.data?.fetchCheyCheyImage;
      if (jsonData?.error === null) {
        dispatch(fetchCheyCheyImageSuccess(jsonData?.data.cheycheys));
      } else {
        dispatch(fetchCheyCheyImageFail(jsonData?.error.message));
      }
    } catch (error: any) {
      dispatch(fetchCheyCheyImageFail("Failed to Chey chey Image"));
    }
  };
};

export const createCheyCheyImageRequest = () => ({
  type: actionTypes.CREATE_CHEYCHEY_IAMGE_REQUEST,
});
export const createCheyCheyImageSuccess = (payload: CheyCheyImageProps) => ({
  type: actionTypes.CREATE_CHEYCHEY_IAMGE_SUCCESS,
  payload,
});
export const createCheyCheyImageFail = (payload: string) => ({
  type: actionTypes.CREATE_CHEYCHEY_IAMGE_FAIL,
  payload,
});

export const createCheyCheyImage = (image:string, type:string, title:string, category:string) => {
  return async (dispatch: any) => {
    try {
      await dispatch(createCheyCheyImageRequest());
      const response = await executeMutation(CREATE_CHEY_CHEY_IMAGE,{image, type, title, category});
      const jsonData = response.data?.createCheyCheyImage;
      if (jsonData?.error === null) {
        dispatch(createCheyCheyImageSuccess(jsonData?.data.cheychey));
        dispatch(showSnackbar("Success! upload chey cehy image."));
      } else {
        dispatch(createCheyCheyImageFail(jsonData?.error.message));
        dispatch(
          showSnackbar(
            `Error :${
              jsonData?.error.message
                ? jsonData?.error.message
                : "Something went wrong"
            }`
          )
        );
      }
    } catch (error: any) {
      dispatch(createCheyCheyImageFail("Something went wrong, please try again"));
    }
  };
};
export const deleteCheyCheyImageRequest = () => ({
  type: actionTypes.DELETE_CHEYCHEY_IAMGE_REQUEST,
});
export const deleteCheyCheyImageSuccess = (payload:string) => ({
  type: actionTypes.DELETE_CHEYCHEY_IAMGE_SUCCESS,
  payload
});
export const deleteCheyCheyImageFail = (payload: string) => ({
  type: actionTypes.DELETE_CHEYCHEY_IAMGE_FAIL,
  payload,
});

export const deleteCheyCheyImage = (chey_chey_id:string) => {
  return async (dispatch: any) => {
    try {
      await dispatch(deleteCheyCheyImageRequest());
      const response = await executeMutation(DELETE_CHEY_CHEY_IMAGE,{chey_chey_id});
      const jsonData = response.data?.deleteCheyCheyImage;
      if (jsonData?.error === null) {
        dispatch(deleteCheyCheyImageSuccess(chey_chey_id));
        dispatch(showSnackbar("Success! upload chey cehy image."));
      } else {
        dispatch(deleteCheyCheyImageFail(jsonData?.error.message));
        dispatch(
          showSnackbar(
            `Error :${
              jsonData?.error.message
                ? jsonData?.error.message
                : "Something went wrong"
            }`
          )
        );
      }
    } catch (error: any) {
      dispatch(deleteCheyCheyImageFail("Something went wrong, please try again"));
    }
  };
};
